import React from "react";
import { Header, Icon, Segment, Table } from "semantic-ui-react";
import { addressFormatter } from "../../../../../common/addressFormatter";

import { FormattedRow } from "./TermPicker";

export default function ViewOnly(props) {
  const terms = [{ ...props.term }];
  const payOffPercentage = () => {
    switch (props.term.term) {
      case 36:
        return "55%";
      case 48:
        return "48%";
      case 60:
        return "45%";
      case 72:
        return "40%";
      default:
        return "n/a";
    }
  };

  const address = addressFormatter(props.address);

  return (
    <Segment padded>
      {address && (
        <div style={{ textAlign: "center" }}>
          <Icon name="map pin" color="blue" size="huge" />
          <Header
            content={address}
            subheader="Location of the system(s)"
            size="large"
            style={{ marginBottom: "20px", marginTop: "10px" }}
            textAlign="center"
          />
        </div>
      )}
      <Table size="large">
        <Table.Body>
          <FormattedRow
            data={terms.map((p) => `$${p.total_hvac_system_cost}`)}
            description="Cost of Unit (Cash Price)"
          />
          {/* <FormattedRow
            data={terms.map(p => parseFloat(props.additionalCost) ? `$${parseFloat(props.additionalCost).toFixed(2)}` : '$0.00')}
            description="Additional Installation Materials"
          /> */}
          <FormattedRow
            data={terms.map((p) => `$${p.cash_total}`)}
            description="Total Cash Price Of Unit"
          />
          <FormattedRow
            data={terms.map((p) => `$${p.minimum_purchase_reserve}`)}
            description="Minimum Contract Reduction"
          />
          <FormattedRow
            data={terms.map((p) => `$${p.additional_down_payment}`)}
            description="Optional Added Cost Reduction"
          />
          <FormattedRow
            data={terms.map((p) => `$${p.total_purchase_reserve}`)}
            description="Total Cost Reduction (Down Payment)"
            warning={true}
          />
          <FormattedRow
            data={terms.map((p) => `$${p.tax_on_deposit}`)}
            description="Tax on Contract Reduction"
          />
          <FormattedRow
            data={terms.map((p) => `$${p.cost_reduction_after_tax}`)}
            description="Contract Reduction after Tax"
          />
          <FormattedRow
            data={terms.map((p) => `$${p.final_cost_of_unit}`)}
            description="Cost of Unit after Contract Reduction (Starting Rent to own amount)"
          />
          <FormattedRow
            data={terms.map((p) => `$${p.monthly_pretax}`)}
            description="Monthly Rent (Pre-tax)"
          />
          <FormattedRow
            data={terms.map((p) => p.tax_rate)}
            description={`Tax Rate (${props.zip ? props.zip : ""}${
              props.taxState ? `, ${props.taxState}` : ""
            })`}
          />
          <FormattedRow
            data={terms.map((p) => `$${p.monthly_tax}`)}
            description="Sales tax"
          />
          <FormattedRow
            data={terms.map((p) => `$${p.total_monthly_payment}`)}
            description="Total Monthly Payment"
            warning={true}
          />
          <FormattedRow
            data={terms.map((p) => `$${p.full_term_payoff}`)}
            description="Total Contract Balance"
          />
          <FormattedRow
            data={[payOffPercentage()]}
            description="Payoff Percentage Customer Pays on Remaining Balance"
          />
          <FormattedRow
            data={terms.map((p) => `${p.term} months`)}
            description="Term Length"
          />
        </Table.Body>
      </Table>
    </Segment>
  );
}
